import { render } from "./PriceAlarm.vue?vue&type=template&id=58749378"
import script from "./PriceAlarm.vue?vue&type=script&lang=js"
export * from "./PriceAlarm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__